import * as yup from 'yup';

export const validationSchema = yup.object().shape({
  projectMemberName: yup
    .string()
    .required('Add Project Member Name is required'),
  projectMemberRole: yup
    .mixed()
    .test('is-object', 'Add Project Member Role is required', (value) => {
      if (Array.isArray(value) && value.length > 0) {
        return true;
      }
      return false;
    }),
  fromDate: yup.date().required('Start date is required'),
  toDate: yup
    .date()
    .required('End date is required')
    .min(yup.ref('fromDate'), 'End date must be later than start date'),
  isMaximumAllocation: yup.boolean(),
  projectMemberAllocation: yup
    .number()
    .required('Project Member Allocation is Required')
    .test(
      'is-number',
      'Project Member Allocation cannot be more than 40',
      function (value) {
        const isMaximumAllocation = this.parent.isMaximumAllocation;
        return value <= 40 || (value > 40 && isMaximumAllocation);
      }
    )
    .positive('Project Member Allocation is Required')
});
